
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 59.9 59.9"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ffd630","fill-opacity":".4","stroke":"#ffd630","stroke-linecap":"square","stroke-width":"1.085","d":"M.8 30L29.9.7l29.2 29.1L30 59.1z","paint-order":"markers fill stroke"}}),_c('g',{attrs:{"fill":"#ffd630","transform":"matrix(.91629 0 0 .77828 15.3 18)"}},[_c('path',{attrs:{"d":"M29.7 25.6l-11-22a3 3 0 00-5.5 0l-10.9 22A3 3 0 005 30h22a3 3 0 002.7-4.4zm-1.9 2a1 1 0 01-.8.4H5a1 1 0 01-.9-.5 1 1 0 010-1l11-22a1 1 0 011.9 0l11 22a1 1 0 01-.2 1z"}}),_c('path',{attrs:{"d":"M15 11h2v9h-2z"}}),_c('circle',{attrs:{"cx":"16","cy":"24","r":"2"}})])])
          )
        }
      }
    